import { status } from '../../helpers'

const getOrderStoreDefaultState = () => {
  return {
    currentMapsUrl: '',
    ordersListLoading: status.INITIALIZED,
    orderDetailLoading: status.INITIALIZED,
    currentOrdersList: [],
    individualOrder: {},
    orderItemsDetail: [],
    shoppingBagProducts: [],
    confirmedOrderForRecipient: null,
    selectedRecipientId: null,
    recipientResourceType: null,
    salesForceRecipient: {},
    maxCharacters: 500,
    cardMessage: '',
    selectedTemplateId: 0,
    selectedShippingOptionId: null,
    currentOrderId: null,
    searchQuery: '',
    disabledPayButton: false,
    salesforceResourceType: '',
    salesforceResourceUID: null,
    isCreatingOrder: false,
    allTeamOrders: [],
    checkInventoryResponse: [],
    shippingRates: [],
    loadingShippingRates: status.LOADED,
    selectedShippingRate: null,
    shippingRateErrorOccur: false,
    order: null,
    // for pagination
    totalRecords: 0
  }
}

export default getOrderStoreDefaultState
